import React, { useState, useEffect, useRef} from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useRouteMatch, useLocation, useHistory } from "react-router-dom";

import _ from 'lodash';

import { generateReportUrl, parseQueryParams } from 'services/report.service';

import { LeadAnalytics } from "../components/leadAnalytics"
import { InteractionAnalytics } from "../components/interactionAnalytics";
import { ReportSummary } from "../components/reportSummary";
import { DatePickerView } from '../components/datePicker';
import { MetricsAnalytics } from "../components/metricsAnalytics";
import { AssetAnalytics } from "../components/assetAnalytics";
import { PageAnalytics } from "../components/pageAnalytics";
import { SessionAnalytics } from "../components/sessionAnalytics";
import { GeographicAnalytics } from "../components/geographicAnalytics"
import { JourneyAnalytics } from "../components/journeyAnalytics";
import styles from '../report.module.scss';
import { fetchAllPagesForLandingStoryboard } from "actions/storyboard";
import { getPageViewedEventPayload } from "services/mixpanelUtil";
import { MIXPANEL_PAGE_VIEWED, MIXPANEL_PAGE_VIEWED_REPORTS, MIXPANEL_PAGE_VIEWED_JOURNEY_REPORTS} from "constants/mixpanelEvents";
import { createMixpanelEvent } from "actions/mixpanel";

export default function LandingReportsView(props) {
  const [reportDate, setReportDate] = useState(null);
  let { url } = useRouteMatch();
  const ref = useRef(null);
  const { search } = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  let { storyboardId } = useParams();
  const storyboardName = useSelector(state => _.get(state, 'storyboards.storyboard.item.name', null));
  const storyboardType = useSelector(state => _.get(state, `storyboards.storyboard.item.type`, null));

  const handleDateChange = (value) => {
    setReportDate(value);
  }

  useEffect(() => {
    if (reportDate) {
      const updatedUrl = generateReportUrl(url, reportDate, search);
      history.replace(updatedUrl);
    }
  }, [reportDate]);

  useEffect(() => {
    const parsedDate = parseQueryParams(search);
    setReportDate(parsedDate);
    dispatch(fetchAllPagesForLandingStoryboard({storyboard: storyboardId}))

    var mixPanelPayload = getPageViewedEventPayload(MIXPANEL_PAGE_VIEWED_REPORTS, storyboardId, storyboardName, storyboardType)
    dispatch(createMixpanelEvent(MIXPANEL_PAGE_VIEWED, mixPanelPayload))

  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        var mixPanelPayload = getPageViewedEventPayload(MIXPANEL_PAGE_VIEWED_JOURNEY_REPORTS, storyboardId, storyboardName, storyboardType)
        dispatch(createMixpanelEvent(MIXPANEL_PAGE_VIEWED, mixPanelPayload)) 
      }
    }, { threshold: 0.1 });
    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);


  return (
    <div className={styles.reportContainer} >
      <ReportSummary
        date={reportDate}
        storyboardType={"LANDING_PAGE"}
      />

      <div className={styles.reportFilters}>
        <DatePickerView
          value={reportDate}
          onChange={handleDateChange}
        />
      </div>

      <div>
        <SessionAnalytics
          date={reportDate}
          storyboardType={"LANDING_PAGE"}
        />
      </div>

      <div className={styles.reportsColumn}>
        <PageAnalytics
          date={reportDate}
          storyboardType={"LANDING_PAGE"}
        />

        <InteractionAnalytics
          date={reportDate}
        />
      </div>

      <div>
        <AssetAnalytics
          date={reportDate}
        />
      </div>

      <div>
        <GeographicAnalytics
          date={reportDate}
          storyboardType={"LANDING_PAGE"}
        />
      </div>

      <div className={styles.reportsColumn}>
        <MetricsAnalytics
          tableName="Device Analytics"
          metricType="device"
          paginationName="Devices"
          date={reportDate}
        />
        <MetricsAnalytics
          tableName="Account Analytics"
          metricType="organization"
          paginationName="Accounts"
          date={reportDate}
        />
      </div>

      <div>
        <LeadAnalytics
          date={reportDate}
        />
      </div>

      {storyboardType === 'RESOURCE_CENTER' &&
        <div ref={ref}>
          <JourneyAnalytics
            date={reportDate}
            storyboardType={"RESOURCE_CENTER"}
          />
        </div>
      }

      <div className={styles.reportsColumn}>
        <MetricsAnalytics
          tableName="UTM Source Analytics"
          metricType="utm_source"
          paginationName="UTM Sources"
          date={reportDate}
        />
        <MetricsAnalytics
          tableName="UTM Medium Analytics"
          metricType="utm_medium"
          paginationName="UTM Mediums"
          date={reportDate}
        />
      </div>
    </div>
  );
}